import { gql } from '@apollo/client';

export const GET_CALLBACK_LINK = gql`
query GetCallBackLink {
    callBackLink @client 
}
`;
